import { FC } from 'react'
import { useTranslation } from "react-i18next"
import { RotationRightButton } from '../../../../components/buttons/iconButtons/action/RotationCollection'
import { HighLightButton } from '../../../../components/buttons/iconButtons/editor/ActionCollection'
import BaseCommandsPanel from '../../../../components/commandsPanels/BaseCommandsPanel'
import Tooltip from '../../../../components/tooltips/Tooltip'
import GridWrapper from '../../../../components/controls/GridWrapper'
import { SearchButtonPanel } from '../../../../components/buttons/iconButtons/action/MainCollection'

interface IPanelEvent {
    disabled?: boolean;
    onClick: () => any;
    onSubItemClick?: () => any;
    value?: any;
}

interface IActRejectionPanelProps {
   
    edit?: IPanelEvent;
    refresh?: IPanelEvent;
    search?: IPanelEvent;
    hasActiveFilters: boolean;
}

export const ActRejectionPanel: FC<IActRejectionPanelProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('documentsCommandsPanel.' + value)
    const activeCommands = {
        edit: true,
        refresh: true,
        search: true,
    }

    return (
        <>
            <GridWrapper cols={1}>
                <BaseCommandsPanel groups={[
                    [
                        
                        {
                            iconButton: <Tooltip title={baseT('viewNote')}>
                                <HighLightButton sizeVariant="mini" {...{ ...props.edit, disabled: props.edit?.disabled || !activeCommands.edit }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title={baseT('refresh')}>
                                <RotationRightButton sizeVariant="mini" {...{ ...props.refresh, disabled: props.refresh?.disabled || !activeCommands.refresh }} />
                            </Tooltip>
                        },
                        {
                            iconButton: <Tooltip title="Поиск">
                                <div style={props.hasActiveFilters ? { backgroundColor: 'rgb(153, 204, 255)', borderRadius: "2px" } : {}}>
                                    <SearchButtonPanel sizeVariant="mini" {...{ ...props.search, disabled: props.search?.disabled || !activeCommands.search }} />
                                </div>
                            </Tooltip>
                        },
                    ],
                ]}
                />
            </GridWrapper>
        </>
    )
}
